import MoreIcon from 'icons/gengduo.svg';
import NavCatogory from 'icons/nav-class.svg';
import NavHome from 'icons/nav-home.svg';
import NavMine from 'icons/nav-me.svg';
import NavOftenbuy from 'icons/nav-oftenbuy.svg';
import NavShoppingCart from 'icons/nav-shoppingcart.svg';
import { UserContext } from 'libs/contexts';
import { amI } from 'libs/user';
import { useRouter } from 'next/router';
import { useContext, useRef } from 'react';
import { Popover } from 'react-vant';
import Kefu from 'icons/service.svg';
import { getWofengService } from 'api/common';
import { getUserDetail } from 'api/user';
import { FeatureEnum, isFeatureActive } from 'libs/features';
import { getWofengServiceParams } from 'libs/utils';

const actions = [
  {
    path: '/',
    icon: NavHome,
    text: '首页',
  },
  {
    path: '/category',
    icon: NavCatogory,
    text: '分类',
  },
  {
    path: '/buy-more',
    icon: NavOftenbuy,
    text: '常购',
  },
  {
    path: '/pages/cart',
    icon: NavShoppingCart,
    text: '购物车',
  },
  {
    path: '/mine',
    icon: NavMine,
    text: '我的',
  },
].filter(Boolean);

const supplierActions = [
  {
    path: '/mine',
    icon: NavMine,
    text: '我的',
  },
];

const buildIcon = (Icon) => {
  return (
    <div className="build-icon">
      <Icon />
      <style jsx>{`
          .build-icon {
            width: 20px;
            margin-right: 8px;
            display: flex;
            justify-content: center;
            align-items: center;
          }
          .build-icon :global(svg) {
            transform: scale(0.7);
          }
          .build-icon :global(path) {
            fill: #ccc;
          }
        `}</style>
    </div>
  );
};

export default function MinNav() {
  const router = useRouter();
  const userInfo = useContext(UserContext);
  const isPurchaser = amI(userInfo, 'purchaser');
  const ref = useRef(null);
  const list = isPurchaser ? actions : supplierActions;
  const key = router.query.appKey as string;

  const toService = async () => {
    const { data } = await getUserDetail();
    const params = await getWofengServiceParams(data);
    const res = await getWofengService(params);
    // NOTE:
    if (res.code === 200) window.location.href = res.data?.h5?.url;
  };
  const onNavClick = (action) => {
    router.push(action.path);
  };

  return (
    <div className="min-nav-container" ref={ref}>
      {isFeatureActive(FeatureEnum?.QiDianService) && key === 'message' ? (
        <div className="service" onClick={toService}>
          <Kefu />
        </div>
      ) : (
        <Popover
          teleport={ref.current}
          placement="bottom-end"
          offset={[10, 8]}
          reference={<MoreIcon />}
        >
          {list.map((item) => (
            <div key={item.path} className="action-item" onClick={() => onNavClick(item)}>
              {buildIcon(item.icon)}
              {item.text}
            </div>
          ))}
        </Popover>
      )}
      <style jsx>{`
        .min-nav-container :global(.rv-popover__arrow) {
          right: 8px;
        }
        .action-item {
          width: 116px;
          height: 36px;
          padding-left: 26px;
          display: flex;
          align-items: center;
          border-bottom: 1px solid #eee;
          font-size: 14px;
          color: #333333;
          text-align: right;
          font-weight: normal;
        }
        .action-item:last-child {
          border-bottom: none;
        }
        .service {
          display: flex;
          justify-content: center;
          align-items: center;
        }
      `}</style>
    </div>
  );
}
